import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";
import Spinner from "core/action/Spinner";
import type React from "react";

const DownloadButtonContent = ({
  loading = false,
}: {
  loading?: boolean;
}): React.ReactElement => {
  return (
    <>
      <Spinner alt={faCloudDownloadAlt} spin={loading} className={"mr-2"} />
      Download
    </>
  );
};

export default DownloadButtonContent;
